import { render, staticRenderFns } from "./GenerateLogo.vue?vue&type=template&id=83e56e44&scoped=true&"
import script from "./GenerateLogo.vue?vue&type=script&lang=js&"
export * from "./GenerateLogo.vue?vue&type=script&lang=js&"
import style0 from "./GenerateLogo.vue?vue&type=style&index=0&id=83e56e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e56e44",
  null
  
)

export default component.exports